export default __webpack_public_path__ + "static/media/self-assessment-oosh-manual.7ada70f3.jpg";